<div class="grid layout container" *ngIf="scanUrlReady === true && newBot">
  <div class="col-12">
    <h1 style="text-align: center; font-weight: 700; font-family: sans-serif; margin-top: 20px">
      Tu sitio web
    </h1>
  </div>
  <div class="col-12 md:col-7 lg:col-7 flex flex-column gap-2">
    <p style="font-weight: 700; margin: 0rem">Ingresa la URL del sitio</p>
    <div class="btn-scan">
      <input
        pInputText
        id="username"
        aria-describedby="username-help"
        [(ngModel)]="urlDatasource"
        placeholder="https://www.ejemplo.com"
        style="flex-grow: 1; margin-right: 1rem"
      />
      <globot-button
        [text]="'Obtener Links'"
        [width]="isMobile ? 'w-100' : 'w-auto'"
        (clickEvent)="obtainLinks()"
        [styleClass]="'primary'"
        [loading]="scanLoading"
      ></globot-button>
    </div>
    <div class="messageWarn" *ngIf="showErrorMessage">
      <i class="pi pi-exclamation-triangle"></i>{{ errorMessage }}
    </div>
    <p class="description-obtain-link">
      Esta acción hará que identifiquemos las páginas asociadas al sitio web
    </p>
    <div class="scan-progress" *ngIf="showScanProgress">
      <div class="scan-progress__row">
        <span class="scan-progress__label">
          <i *ngIf="scanDone" class="pi pi-check-circle scan-progress__check"></i>
          <i *ngIf="!scanDone" class="pi pi-spin pi-spinner"></i>
          <span *ngIf="scanDone">
            Listo — {{ links.length }}
            {{ links.length === 1 ? 'página encontrada' : 'páginas encontradas' }}
          </span>
          <span *ngIf="!scanDone">Buscando páginas del sitio…</span>
        </span>
        <span class="scan-progress__count" *ngIf="!scanDone && links.length > 0">
          {{ links.length }} encontradas
        </span>
      </div>
      <p-progressBar
        *ngIf="!scanDone"
        mode="indeterminate"
        [style]="{ height: '6px' }"
      ></p-progressBar>
    </div>
  </div>
  <div class="scan-group" *ngIf="links.length > 0" style="text-align: -webkit-center">
    <div
      class="col-12 md:col-7 lg:col-7 flex flex-column gap-2"
      style="margin-top: 1rem; height: 10px"
    >
      <div
        *ngFor="let link of links"
        class="link-item"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1rem;
        "
      >
        <input pInputText [value]="link.url" readonly style="flex-grow: 1; margin-right: 1rem" />
        <button
          pButton
          class="p-link"
          icon="pi pi-trash"
          (click)="removeLink(link.id)"
          style="
            flex-shrink: 0;
            background-color: transparent;
            color: var(--color-error);
            margin-top: 10px;
          "
        ></button>
      </div>
    </div>
  </div>
</div>

<div class="grid layout" *ngIf="scanUrlReady === false && newBot">
  <div class="col-12">
    <h1 style="text-align: center">Sitio web</h1>
  </div>
  <div class="col-12 md:col-5 lg:col-5 flex flex-column gap-2">
    <p style="font-weight: 700; margin: 0rem">URL del sitio web <b style="color: red">*</b></p>
    <input
      pInputText
      id="username"
      aria-describedby="username-help"
      [(ngModel)]="urlDatasource"
      placeholder="https://www.ejemplo.com"
    />
    <div class="messageWarn" *ngIf="showErrorMessage">
      <i class="pi pi-exclamation-triangle"></i>{{ errorMessage }}
    </div>
  </div>
</div>
<div *ngIf="newBot">
  <div
    style="position: absolute; bottom: 10px; left: 10px"
    [ngStyle]="isMobile ? { width: 'calc(50% - 20px)' } : { width: 'auto' }"
  >
    <globot-button
      [text]="'Volver'"
      [width]="isMobile ? 'w-100' : 'w-auto'"
      [icon]="'pi pi-arrow-left'"
      [iconPosition]="'left'"
      [styleClass]="'secondary'"
      (clickEvent)="back()"
    ></globot-button>
  </div>
  <div
    *ngIf="links.length > 0"
    style="position: absolute; bottom: 10px; right: 10px; text-align: right"
    [ngStyle]="isMobile ? { width: 'calc(50% - 20px)' } : { width: 'auto' }"
  >
    <globot-button
      [text]="'Siguiente'"
      [width]="isMobile ? 'w-100' : 'w-auto'"
      [icon]="'pi pi-arrow-right'"
      [iconPosition]="'right'"
      (clickEvent)="setUrlDataSource()"
    ></globot-button>
  </div>
</div>

<div *ngIf="newBot">
  <div
    style="position: absolute; bottom: 10px; left: 10px"
    [ngStyle]="isMobile ? { width: 'calc(50% - 20px)' } : { width: 'auto' }"
  >
    <globot-button
      [text]="'Volver'"
      [width]="isMobile ? 'w-100' : 'w-auto'"
      [icon]="'pi pi-arrow-left'"
      [iconPosition]="'left'"
      [styleClass]="'secondary'"
      (clickEvent)="back()"
    ></globot-button>
  </div>
  <div
    *ngIf="links.length > 0"
    style="position: absolute; bottom: 10px; right: 10px; text-align: right"
    [ngStyle]="isMobile ? { width: 'calc(50% - 20px)' } : { width: 'auto' }"
  >
    <globot-button
      [text]="'Siguiente'"
      [width]="isMobile ? 'w-100' : 'w-auto'"
      [icon]="'pi pi-arrow-right'"
      [iconPosition]="'right'"
      (clickEvent)="scanUrlReady === false ? setUrlDataSource() : uploadUrls()"
    ></globot-button>
  </div>
</div>

<div class="layout-modal" *ngIf="scanUrlReady === true && !newBot">
  <div class="flex flex-column gap-2">
    <p style="font-weight: 700; margin: 0rem">URL del sitio web</p>
  </div>
  <div
    class="scrollable-content"
    [ngStyle]="{ 'min-height': links.length > 0 ? '300px' : '125px' }"
  >
    <div class="btn-scan">
      <input
        pInputText
        id="username"
        aria-describedby="username-help"
        [(ngModel)]="urlDatasource"
        placeholder="https://www.ejemplo.com"
        style="flex-grow: 1"
      />
      <globot-button
        [text]="'Obtener Links'"
        [width]="isMobile ? 'w-100' : 'w-auto'"
        (clickEvent)="obtainLinks()"
        [styleClass]="'primary'"
        [loading]="scanLoading"
      ></globot-button>
    </div>
    <div class="messageWarn" *ngIf="showErrorMessage">
      <i class="pi pi-exclamation-triangle"></i>{{ errorMessage }}
    </div>
    <p class="description-obtain-link">
      Esta acción hará que identifiquemos las páginas asociadas al sitio web
    </p>
    <div class="scan-progress" *ngIf="showScanProgress">
      <div class="scan-progress__row">
        <span class="scan-progress__label">
          <i *ngIf="scanDone" class="pi pi-check-circle scan-progress__check"></i>
          <i *ngIf="!scanDone" class="pi pi-spin pi-spinner"></i>
          <span *ngIf="scanDone">
            Listo — {{ links.length }}
            {{ links.length === 1 ? 'página encontrada' : 'páginas encontradas' }}
          </span>
          <span *ngIf="!scanDone">Buscando páginas del sitio…</span>
        </span>
        <span class="scan-progress__count" *ngIf="!scanDone && links.length > 0">
          {{ links.length }} encontradas
        </span>
      </div>
      <p-progressBar
        *ngIf="!scanDone"
        mode="indeterminate"
        [style]="{ height: '6px' }"
      ></p-progressBar>
    </div>
    <div *ngIf="links.length > 0" style="text-align: -webkit-center; margin-top: 10px">
      <div class="flex flex-column" style="margin-bottom: 8px; height: 10px">
        <div
          *ngFor="let link of links"
          class="link-item"
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1rem;
          "
        >
          <input pInputText [value]="link.url" readonly style="flex-grow: 1; margin-right: 1rem" />
          <button
            pButton
            class="p-link"
            icon="pi pi-trash"
            (click)="removeLink(link.id)"
            style="flex-shrink: 0; background-color: transparent; color: var(--color-error)"
          ></button>
        </div>
      </div>
    </div>
  </div>

  <div class="action-buttons" *ngIf="links.length > 0">
    <div [ngStyle]="isMobile ? { width: 'calc(50% - 20px)' } : { width: 'auto' }">
      <globot-button
        [text]="'Volver'"
        [width]="isMobile ? 'w-100' : 'w-auto'"
        [icon]="'pi pi-arrow-left'"
        [iconPosition]="'left'"
        [styleClass]="'secondary'"
        (clickEvent)="backAndDeleteJob()"
      ></globot-button>
    </div>
    <div [ngStyle]="isMobile ? { width: 'calc(50% - 20px)' } : { width: 'auto' }">
      <globot-button
        [text]="'Agregar'"
        [width]="isMobile ? 'w-100' : 'w-auto'"
        [icon]="'pi pi-arrow-right'"
        [iconPosition]="'right'"
        (clickEvent)="uploadUrls()"
      ></globot-button>
    </div>
  </div>
</div>

<div class="layout-modal" *ngIf="scanUrlReady === false && !newBot">
  <p style="font-weight: 700; margin: 0rem">URL del sitio web <b style="color: red">*</b></p>
  <input
    style="width: 270px"
    pInputText
    id="username"
    aria-describedby="username-help"
    [(ngModel)]="urlDatasource"
  />
  <div class="messageWarn" *ngIf="showErrorMessage">
    <i class="pi pi-exclamation-triangle"></i>{{ errorMessage }}
  </div>

  <div
    style="position: absolute; bottom: 10px; left: 10px"
    [ngStyle]="isMobile ? { width: 'calc(50% - 20px)' } : { width: 'auto' }"
  >
    <globot-button
      [text]="'Volver'"
      [width]="isMobile ? 'w-100' : 'w-auto'"
      [icon]="'pi pi-arrow-left'"
      [iconPosition]="'left'"
      [styleClass]="'secondary'"
      (clickEvent)="back()"
    ></globot-button>
  </div>
  <div
    style="position: absolute; bottom: 10px; right: 10px"
    [ngStyle]="isMobile ? { width: 'calc(50% - 20px)' } : { width: 'auto' }"
  >
    <globot-button
      [text]="'Agregar'"
      [width]="isMobile ? 'w-100' : 'w-auto'"
      (clickEvent)="setUrlDataSource()"
    ></globot-button>
  </div>
</div>
